import { HeaderCell } from '@components/Table/table.styled';
import { flexRender, Header } from '@tanstack/react-table';
import { MaterialIcons } from '@expo/vector-icons';
import React, { useMemo } from 'react';
import { HeaderButton } from '@components/Table/TableHeader/tableHeader.styled';

interface TableHeaderProps<T> {
  header: Header<T, unknown>;
}
export function TableHeader<T>({
  header,
}: TableHeaderProps<T>): React.ReactNode {
  const sortingValue = header.column.getIsSorted();
  const headerButton = useMemo((): React.ReactNode => {
    let sortingIcon = <></>;

    switch (sortingValue) {
      case 'asc':
        sortingIcon = (
          <MaterialIcons name="keyboard-arrow-up" size={24} color="black" />
        );
        break;
      case 'desc':
        sortingIcon = (
          <MaterialIcons name="keyboard-arrow-down" size={24} color="black" />
        );
        break;
    }
    return (
      <HeaderButton onPress={header.column.getToggleSortingHandler()}>
        {flexRender(header.column.columnDef.header, header.getContext())}
        {sortingIcon}
      </HeaderButton>
    );
  }, [header, sortingValue]);

  return (
    <HeaderCell
      key={header.id}
      align="left"
      style={{ width: header.getSize() }}
    >
      {header.column.getCanSort()
        ? headerButton
        : flexRender(header.column.columnDef.header, header.getContext())}
    </HeaderCell>
  );
}
